import { Paragraph1 } from 'inpock-ui-react';

import { CONTENT_CATEGORY } from '@/constants';

import * as S from './styled';

interface TabProps {
  tabs: string[];
  onClick: (category: string) => void;
  activeTab?: string;
}

export function MarketTab({ tabs, onClick, activeTab }: TabProps) {
  const tabToRender = ['all', ...tabs];

  const tabLabel = (value: string) => {
    if (value === 'all') return '전체상품';
    return CONTENT_CATEGORY[value];
  };

  const onClickTab = (label: string) => {
    onClick(label);
  };

  return (
    <S.TabContainer>
      {tabToRender.map((tab) => (
        <S.Tab key={tab} onClick={() => onClickTab(tab)}>
          <Paragraph1
            className={`tab-label ${
              tab === activeTab ? 'text-bold text-gray-800' : 'text-gray-400'
            }`}
            style={{ whiteSpace: 'nowrap' }}
          >
            {tabLabel(tab)}
          </Paragraph1>
        </S.Tab>
      ))}
    </S.TabContainer>
  );
}
